/* Generic peek-slider — arrow buttons scroll a native scroll-snap track by one card's
   width. Reused by locations, catering-services (and anything else with the same
   [data-track]/[data-prev]/[data-next] markup) rather than duplicating this per section. */
class LocationsSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));
    /* Opt-in (locations only): the fully-visible card(s) read sharp, the partially-visible
       peeking card(s) at the track edges get blurred/dimmed via `.is-peek` (client 2026-07-21).
       Gated on `data-blur-peek` so the reused catering/menu peek-carousels are unaffected. */
    if (this.hasAttribute('data-blur-peek') && 'IntersectionObserver' in window) {
      this.blurObserver = new IntersectionObserver(
        (entries) => entries.forEach((e) => e.target.classList.toggle('is-peek', e.intersectionRatio < 0.92)),
        { root: this.track, threshold: [0, 0.5, 0.92, 1] }
      );
      Array.from(this.track.children).forEach((card) => this.blurObserver.observe(card));
    }
  }

  step(dir) {
    const card = this.track.firstElementChild;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 18;
    const amount = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.85;
    this.track.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }
}

if (!customElements.get('locations-slider')) {
  customElements.define('locations-slider', LocationsSlider);
}
